import { render } from "./PO.vue?vue&type=template&id=4f728248"
import script from "./PO.vue?vue&type=script&lang=js"
export * from "./PO.vue?vue&type=script&lang=js"
script.render = render

export default script